import React from "react";
import { FormInput, InputGroup, InputGroupAddon, InputGroupText } from "../../../components/ui";
import { Navigate } from "react-router-dom";

export default class NavbarSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  changeSearchTerm = event => {
    this.setState({
      searchTerm: event.target.value
    });
  };

  doSearch = event => {
    event.preventDefault();
    this.setState({
      redirect: true,
      pathname: "/search",
      state: {
        term: this.state.searchTerm
      }
    });
  };

  render() {
    return (
      <form
        className="main-navbar__search w-100 d-none d-md-flex d-lg-flex"
        onSubmit={this.doSearch}
      >
        {this.state.redirect && (
          <Navigate
            to={{
              pathname: this.state.pathname,
              state: this.state.state
            }}
          />
        )}
        <InputGroup seamless className="ml-3">
          <InputGroupAddon type="prepend">
            <InputGroupText>
              <i className="material-icons">search</i>
            </InputGroupText>
          </InputGroupAddon>
          <FormInput
            style={{ fontSize: "0.875rem" }}
            className="navbar-search"
            placeholder="Search ..."
            value={this.state.searchTerm}
            onChange={this.changeSearchTerm}
          />
        </InputGroup>
      </form>
    );
  }
}
